import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmVatApi } from './types';

export const emVat: TEmVatApi = {
	getEmVatList: payload => http.post(endpoint.emVat.LIST, payload).then(response => response.data),
	createEmVat: payload => http.post(endpoint.emVat.CREATE(payload.vatType), payload.body),
	updateEmVat: payload =>
		http.put(endpoint.emVat.UPDATE(payload.vatType, payload.id), payload.body),
	deleteEmVat: payload => http.delete(endpoint.emVat.DELETE(payload.vatType, payload.id)),
};
